// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

export const firebaseConfig = {
   apiKey: "AIzaSyDnQdMwFSZXco3Rl41aBbX92rRscVIHygg",
  authDomain: "birthday-f5b04.firebaseapp.com",
  projectId: "birthday-f5b04",
  storageBucket: "birthday-f5b04.firebasestorage.app",
  messagingSenderId: "65368227004",
  appId: "1:65368227004:web:dbdad65263dbcf19d1a4b9",
  measurementId: "G-NBSX53HRT0"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

// Auth ready promise
export const authReady = new Promise((resolve) => {
  const unsubscribe = auth.onAuthStateChanged((user) => {
    unsubscribe();
    resolve(user);
  });
});

// Mirror DB (placeholder for now)
export const mirrorDb = null;
